import ArticleTemplate from '@/pages/article/components/ArticleTemplate';
import { articleWysylka } from '@/mocks/articles';

export default function ArticleWysylka() {
  return <ArticleTemplate data={articleWysylka} />;
}